const KEY_PREFIX = 'novax:avatar:';

export interface AvatarConfig {
  imageUrl?: string;
  presetColor?: string;
}

export function getAvatar(botName: string): AvatarConfig {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + botName);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveAvatar(botName: string, config: AvatarConfig) {
  localStorage.setItem(KEY_PREFIX + botName, JSON.stringify(config));
}
